import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { CONFIG } from "../../Components/Commons/constants/constant";

export const settingApi = createApi({
  reducerPath: "settingApi",
  baseQuery: fetchBaseQuery({
    baseUrl: CONFIG.API_URL,
    prepareHeaders: (headers) => {
      headers.set("Access-Control-Allow-Origin", "*");
      headers.set("authorization", localStorage.getItem("jwt_token") || "");
      return headers;
    },
  }),
  endpoints: (builder) => ({
    changePassword: builder.mutation({
      query: (data) => ({
        url: "settings/changePassword",
        method: "POST",
        body: data,
      }),
    }),
    updatePublicKeyCrypto: builder.mutation({
      query: (data) => ({
        url: "settings/updatePublicKeyCrypto",
        method: "POST",
        body: data,
      }),
    }),
    getPublicKeyCrypto: builder.query({
      query: () => ({
        url: "settings/getPublicKeyCrypto",
        method: "GET",
      }),
    }),
  }),

});

export const { useChangePasswordMutation, useUpdatePublicKeyCryptoMutation, useGetPublicKeyCryptoQuery } = settingApi;
export default settingApi;
